<cotecna-toolbar
  [options]="toolbarOptions"
  (closeClicked)="onToolbarCloseActionClicked()"
  (actionClicked)="onToolbarActionClicked($event)"
  >
  @if (status) {
    <mat-chip-option class="chip">
      Status: <span class="status">{{ status }}</span>
    </mat-chip-option>
  }
</cotecna-toolbar>

<cotecna-tabs
  #dynamicTabs
  [tabs]="inspectionTabs"
  (tabChanged)="onTabChanged($event)"
  >
</cotecna-tabs>

<div class="inspection-tabs-content">
  <router-outlet></router-outlet>
</div>
